import React, { useCallback, useState } from "react";
import { v4 } from "uuid";

interface CheckBoxGroupProps {
  name?: string;
  onChange?: any;
  defaultValue?: any;
  children?: any;
  setFilled?: () => void;
  className?: string;
}

interface CheckBoxItemProps {
  setSelected?: Function;
  value?: string;
  onChange?: Function;
  id?: any;
  checked?: boolean;
  disabled?: boolean;
  readonly?: boolean;
  name?: any;
  children?: any;
  className?: string;
  checkBoxWrapperStyle?: string;
}
export function CheckBoxGroup({
  name,
  onChange,
  defaultValue,
  children,
  setFilled,
  className,
  ...rest
}: CheckBoxGroupProps) {
  const childrenArray = React.Children.toArray(children);
  const [selected, setSelected] = useState([]);
  const [name_, setName] = useState(name ?? v4());
  const handleSelect = useCallback(
    (value: never, e) => {
      const newArray = selected.filter((value_) => value_ !== value);
      // if (checked) {
      newArray.push(value);
      // }
      setFilled && setFilled();
      setSelected(newArray);
      onChange && onChange(e);
    },
    [onChange, selected, setFilled]
  );
  return (
    <div className={className}>
      {childrenArray.map((child) =>
        React.cloneElement(child as React.ReactElement<any>, {
          name: name_,
          setSelected: handleSelect,
        })
      )}
    </div>
  );
}

export function CheckBoxItem({
  setSelected,
  value,
  checked,
  onChange,
  disabled,
  readonly,
  id,
  name,
  children,
  className,
  checkBoxWrapperStyle,
  ...rest
}: CheckBoxItemProps) {
  return (
    <div className={checkBoxWrapperStyle}>
      <input
        name={name}
        type="checkbox"
        value={value}
        id={id}
        checked={checked}
        disabled={disabled}
        readOnly={readonly}
        onChange={(e) => {
          onChange && onChange(e);
          setSelected && setSelected(value, e);
        }}
        className={className}
      />
      {children}
    </div>
  );
}
